
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/[pair]",
      function () {
        return require("private-next-pages/compare/[pair].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/[pair]"])
      });
    }
  